var exports = {
  "ci": "TextareaInput.module__textareaContainer___ZUdsME",
  "yF": "TextareaInput.module__divider___ZUdsME",
  "Ot": "TextareaInput.module__textareaOuter___ZUdsME",
  "WJ": "TextareaInput.module__collapsibleSection___ZUdsME",
  "qp": "TextareaInput.module__inputSection___ZUdsME",
  "aq": "TextareaInput.module__textareaOuterMobile___ZUdsME",
  "AE": "TextareaInput.module__mainWrapperDense___ZUdsME",
  "bx": "TextareaInput.module__mainWrapperEditing___ZUdsME",
  "m$": "TextareaInput.module__uploadButtonColumn___ZUdsME",
  "D4": "TextareaInput.module__sideButtonPadding___ZUdsME",
  "Qh": "TextareaInput.module__plusButtonAboveBackdrop___ZUdsME",
  "Sr": "TextareaInput.module__contentAreaDense___ZUdsME",
  "h": "TextareaInput.module__contentAreaEditing___ZUdsME",
  "l7": "TextareaInput.module__buttonContainerDense___ZUdsME",
  "ae": "TextareaInput.module__buttonContainerEditing___ZUdsME",
  "ou": "TextareaInput.module__textareaOuterRow___ZUdsME",
};

module.exports = exports;
